/**
 * Utility methods for VITE environments
 */

import { Capacitor } from '@capacitor/core'

import { environment } from '@/config/environment'

function isProduction(): boolean {
  return environment.env === 'production'
}

function isIOS(): boolean {
  return Capacitor.getPlatform() === 'ios'
}

function isAndroid(): boolean {
  return Capacitor.getPlatform() === 'android'
}

function isWeb(): boolean {
  return Capacitor.getPlatform() === 'web'
}

const DEV_APP_ID = 'be.mariamiddelares.app.dev'
const STAGING_APP_ID = 'be.mariamiddelares.app.stg'
const PROD_APP_ID = 'be.mariamiddelares.app'

export { DEV_APP_ID, isAndroid, isIOS, isProduction, isWeb, PROD_APP_ID, STAGING_APP_ID }
